import React from 'react';
import { useSelector } from 'react-redux';

// Store entities
import { getCompanyState } from '../../../store/company/company.selectors';

// Styles
import './balance-notification.scss';

export const BalanceNotification = () => {

  const { company } = useSelector(getCompanyState);

  let text = '';
  if (company?.is_not_enough_minutes && company?.is_not_enough_request) {
    text = 'Your Video, Voice, Text, Request balance is empty. Please contact support@paypertok.com';
  } else if (company?.is_not_enough_minutes) {
    text = 'Your Video, Voice, Text balance is running low. Please contact support@paypertok.com';
  } else if (company?.is_not_enough_request) {
    text = 'Your Request balance is empty. Please contact support@paypertok.com';
  }

  return (
    <div className="balance-notification" hidden={ !company?.is_not_enough_minutes && !company?.is_not_enough_request }>
      <div className="balance-notification--title">{ text }</div>
    </div>
  );
}
